import type { OsasZorgDomeinReferralCustomControlData } from '@common/validation/customControls/osas/osasZorgDomeinReferralSchemas/osasZorgDomeinReferralSchema';
import { initialData as osasReferralInitialData } from '../osasReferral/osasReferralData';

export const initialData: OsasZorgDomeinReferralCustomControlData = {
    ...osasReferralInitialData,
    patientUsesMedication: false,
    referrerOrganizationId: null,
    referrerPractitionerId: null,
};
